// extracted by mini-css-extract-plugin
export default {"section":"FeFhSCkhShZId7wZJDaD"};